import {Component, Input, OnInit} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {Piece} from '../../../../models/piece.model';
import {DossierInterventionService} from '../../../../services/dossier_intervention.service';
import {NomPieceService} from '../../../../services/nom-piece.service';
import {NomPiece} from '../../../../models/nomPiece.model';
import {RevetementPlancherService} from '../../../../services/revetement-plancher.service';
import { RevetementPlancher } from 'app/models/revetementPlancher.model';
import { Niveau } from 'app/models/niveau.model';
import { EtageService } from 'app/services/etage.service';
import { Etage } from 'app/models/etage.model';

@Component({
    selector: 'app-modal-piece',
    templateUrl: './modal-piece.component.html'
})
export class ModalPieceComponent implements OnInit {
    @Input() idDossierIntervention: number;
    @Input() piece: Piece = new Piece();
    @Input() niveau: Niveau = new Niveau();
    @Input() pieces: Piece[] = [];
    @Input() revetements: string[] = [];

    nomPieces: NomPiece[] = [];
    revetementPlanchers: RevetementPlancher[] = [];
    niveaux: Etage[] = [];

    success: boolean = false;
    error: boolean = false;
    form: FormGroup;

    piecesForFilter = [
        'Bureau',
        'Chambre des maîtres',
        'Chambre secondaire 1',
        'Chambre secondaire 2',
        'Chambre secondaire 3',
        'Cuisine',
        'Garage',
        'Hall d\'entrée',
        'Salle à dîner',
        'Salle de bain 1',
        'Salle de bain 2',
        'Salle d\'eau',
        'Salle de lavage',
        'Salle familiale/salon',
        'Salle mécanique et atelier',
        'Salle de rangement',
        'Autre'
    ];

    get lowerCasePiecesForFilter(): string[] {
        return this.piecesForFilter.map(piece => piece.toLowerCase());
    }

    get nomPiecesAutofill(): Array<string> {
        if (!this.form.value?.nom_piece) {
            return this.piecesForFilter;
        }

        const filterValue = this.form.value?.nom_piece?.toLowerCase();

        return this.piecesForFilter.filter(pieceToFilter => pieceToFilter.toLowerCase().includes(filterValue.toLowerCase()));
    }

    get revetementsPlanchersAutofill(): Array<RevetementPlancher> {
        if (!this.form.value?.revetement_plancher) {
            return this.revetementPlanchers;
        }
        return this.revetementPlanchers.filter(revetement => revetement?.revetement.toLowerCase().includes(this.form.value?.revetement_plancher?.toLowerCase()));
    }

    get niveauxAutofill() {
        if (!this.form.value?.nom_niveau) {
            return this.niveaux;
        }

        return this.niveaux.filter(niveaux => niveaux?.nom_niveau.toLowerCase().includes(this.form.value?.nom_niveau?.toLowerCase()));
      }

    constructor(
        public dialogRef: MatDialogRef<ModalPieceComponent>,
        private dossierInterventionService: DossierInterventionService,
        private nomPieceService: NomPieceService,
        private revetementService: RevetementPlancherService,
        private etageService: EtageService,
    ) {
    }

    ngOnInit(): void {

        let nomPiece = '';
        if (this.piece?.nom_piece) {
            nomPiece = 'Autre';
            if (this.lowerCasePiecesForFilter.includes(this.piece.nom_piece.toLowerCase()) ) {
                nomPiece = this.piecesForFilter[this.lowerCasePiecesForFilter.indexOf(this.piece.nom_piece.toLowerCase())];
            }
        }

        this.form = new FormGroup({
            id: new FormControl(this.piece.id),
            dossier_intervention_id: new FormControl(this.idDossierIntervention),
            nom_piece: new FormControl(nomPiece, [Validators.required]),
            nom_niveau: new FormControl(this.piece.nom_niveau),
            largeur: new FormControl(this.piece.largeur),
            hauteur: new FormControl(this.piece.hauteur),
            longueur: new FormControl(this.piece.longueur),
            revetement_plancher: new FormControl(this.piece.revetement_plancher, [Validators.required]),
            autrePiece: new FormControl(nomPiece === 'Autre' ? this.piece.nom_piece : null),
        });
        this.fetchNomPieces();
        this.fetchRevetements();
        this.fetchNiveaux();
    }

    fetchNomPieces(): void {
        this.nomPieceService.getNomsPieces().subscribe((nomPieces) => {
            this.nomPieces = nomPieces;
        });
    }
    fetchRevetements(): void {
        this.revetementService.getRevetementsPlanchers().subscribe((revetementPlanchers) => {
            this.revetementPlanchers = revetementPlanchers;
        });
    }

    fetchNiveaux(): void {
        this.etageService.getEtages(this.idDossierIntervention).subscribe((niveaux) => {
            this.niveaux = niveaux;
        });
    }

    onFormSubmit(): void {
        this.error = false;
        this.success = false;
        this.form.markAllAsTouched();

        if (this.form.valid) {
          const piece = new Piece(this.form.value);
          if (piece.nom_piece === 'Autre') {
            piece.nom_piece = this.form.value.autrePiece;
          }

          this.dossierInterventionService.storeOrUpdatePieceForDossierIntervention(this.idDossierIntervention, piece).subscribe(
              (response) => {
                  this.success = true;
                  this.dialogRef.close(response);
              }, (error) => { this.error = true; }
          );

        }
    }
}
